// src/components/sustainability/EthicalProduction.js
import React, { useEffect, useRef } from 'react';
import { fadeIn, slideIn } from '../../utils/gsapAnimations';

function EthicalProduction({ content }) {
  const textRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    fadeIn(textRef.current, 0.3);
    slideIn(imageRef.current, 'right', 0.5);
  }, []);

  return (
    <div className="flex flex-col lg:flex-row-reverse items-center py-12 px-4 gap-8 bg-primary text-cream">
      <div ref={textRef} className="w-full lg:w-1/2 text-center lg:text-left">
        <h2 className="text-2xl font-lora font-semibold mb-4">
          {content?.title || 'Ethical Production'}
        </h2>
        <p className="text-poppins mb-4">
          {content?.description ||
            'Our garments are made in factories that prioritize fair wages, safe working conditions, and respect for workers’ rights. We partner with manufacturers who share our commitment to ethical and transparent production.'}
        </p>
      </div>
      <div ref={imageRef} className="w-full lg:w-1/2">
        <img
          src={content?.image || 'https://via.placeholder.com/600x400?text=Ethical+Production'}
          alt={content?.imageAlt || 'Ethical Production'}
          className="w-full h-auto rounded-lg"
        />
      </div>
    </div>
  );
}

export default EthicalProduction;